var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCloudUpload = function SvgCloudUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.21 11.29a1 1 0 0 0-1.4 0l-3 2.9a.999.999 0 1 0 1.38 1.44l1.31-1.27V20a1 1 0 1 0 2 0v-5.59l1.29 1.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-3-3Z",
    fill: "#4673EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.17 7A6 6 0 0 0 6.83 7a5 5 0 0 0-3.08 8.27A1 1 0 1 0 5.25 14 3 3 0 0 1 7.5 9h.1a1 1 0 0 0 1-.8 4 4 0 0 1 7.84 0 1 1 0 0 0 1 .8h.06a3 3 0 0 1 2.25 5 1 1 0 0 0 .09 1.42 1 1 0 0 0 1.41-.09A5 5 0 0 0 18.17 7Z",
    fill: "#4673EC"
  })));
};

export default SvgCloudUpload;